import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../centerWarehouse/facilityInternalRequest/ContextAPI';
import Index from '../centerWarehouse/facilityInternalRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestCentral() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-central-init']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
